module.exports = __webpack_public_path__ + "static/media/ic_radio_button_checked.2bee36d7.svg";